import { render, staticRenderFns } from "./AssignTaskModal.vue?vue&type=template&id=123ecbae&scoped=true&"
import script from "./AssignTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssignTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignTaskModal.vue?vue&type=style&index=0&id=123ecbae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ecbae",
  null
  
)

export default component.exports